import {DateFormat} from "../../date_format"
import messageResource from "../../messageResource"
import ParametersFormatter from "../../reports/estimatedVsActualReport/ParametersFormatter"
import BaseReportFormatUtils from "../../reports/FormatUtils"
import ChartPDFSingleDateFormattingStrategy from '../../reports/charts/pdfgenerator/formatters/ChartPDFSingleDateFormattingStrategy'

export default class PDFParametersFormattingStrategy {

    init(config) {
        this.productSettingsValidator = config.productSettingsValidator;
        this.reportRightsValidator = config.reportRightsValidator;
        this.dateParametersFormattingStrategy = this.createDateParametersFormattingStrategy(config.dateFormat, config.dateFormatForFile);

        this.shortDateFormat = new DateFormat(window.SystemSettings.dateFormat);
        this.parametersFormatter = new ParametersFormatter().init({selectorsData: config, dateFormat: config.dateFormat});
        return this;
    }

    createDateParametersFormattingStrategy(dateFormat, dateFormatForFile) {
        return new ChartPDFSingleDateFormattingStrategy(dateFormat, dateFormatForFile)
    }

    formatChartPDFFilterInformation(selectedParameters, assignedInfo) {
        return {
            firstRow: this.formatCPSelection(selectedParameters),
            secondRow: this.formatAdditionalInfo(selectedParameters)
        }
    }

    formatCPSelection(selectedParameters) {
        return this.parametersFormatter.formatCustomersAndProjectsSelection(selectedParameters.customersProjectsSelection);
    }

    formatAdditionalInfo(selectedParameters) {
        return this.parametersFormatter.formatTaskSelectionParamsString(selectedParameters.tasksConfig,
            selectedParameters.includeNotEstimated,
            selectedParameters.includeNotStarted,
            {dateSelection: selectedParameters.dateSelection, isParsed: true});
    }

    formatChartPDFHeaderDateInformation(selectedParameters) {
        return this.dateParametersFormattingStrategy.formatDateInformation(selectedParameters);
    }

    formatChartPDFFileName(selectedParameters) {
        var dateRange = selectedParameters.dateSelection;
        var formattedDateRange = "(" + this.shortDateFormat.formatDate(dateRange.date) + ")";

        var fileNameParts = [];
        fileNameParts.push(messageResource.getMessage('estimate_vs_actual_report.pdf.title'));
        fileNameParts.push(formattedDateRange);

        return messageResource.getMessage('common.leave.reports.pdf.file_name', fileNameParts);
    }

    _makePDFTitle(andSubstitutionKey) {
        return messageResource.getMessage('estimate_vs_actual_report.pdf.title');
    }

    formatChartPDFHeaderTitle(selectedParameters) {
        return messageResource.getMessage('common.leave.reports.pdf.header.report', [this._makePDFTitle()]);
    }

    formatChartPDFReportTitle(selectedParameters) {
        var showBy = BaseReportFormatUtils.formatGroupingLevel(selectedParameters.firstGroupingLevel);
        return messageResource.getMessage('common.leave.reports.pdf.header.report_by', [this._makePDFTitle(), showBy]);
    }
}



// WEBPACK FOOTER //
// ./web/js/pdf/evaReport/PDFParametersFormattingStrategy.js